var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section",attrs:{"id":"track-and-trace"}},[_c('div',{staticClass:"section-inner"},[_c('div',{staticClass:"column is-full"},[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.enabled)?_c('router-view'):_c('p',[_vm._v(_vm._s(_vm.message))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }